"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalToken = exports.setGlobalToken = void 0;
let currentToken = null;
const setGlobalToken = (token) => {
    currentToken = token;
};
exports.setGlobalToken = setGlobalToken;
const getGlobalToken = () => currentToken;
exports.getGlobalToken = getGlobalToken;
